import { render, staticRenderFns } from "./PlatDataPanelUniformExam.vue?vue&type=template&id=42d47c0e"
import script from "./PlatDataPanelUniformExam.vue?vue&type=script&lang=js"
export * from "./PlatDataPanelUniformExam.vue?vue&type=script&lang=js"
import style0 from "./PlatDataPanelUniformExam.vue?vue&type=style&index=0&id=42d47c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports